import { ServiceType } from "../ServiceManager";
import { IGeocoder } from "./IGeocoder";
import { APIRequest, APIRequestMethod } from "../API/APIRequest";
import { WebsiteGeocoderProviderConfig } from "../../types/WebsiteConfig";
import Coordinate from "../../types/Coordinate";
import { Client } from "../API/Client";
import { Logger, LogLevel } from "../Logger";

interface GoogleMapsGeocodingResults {
    results: GoogleMapsGeocodingResult[];
}

interface GoogleMapsGeocodingResult {
    address_components: GoogleMapsGeocodingResultAddressComponent[];
    formatted_address: string;
    geometry: GoogleMapsGeocodingResultGeometry;
    place_id: string;
    types: string[];
}

interface GoogleMapsGeocodingResultGeometry {
    bounds?: GoogleMapsGeocodingResultBounds;
    location: GoogleMapsGeocodingResultCoord;
    location_type: string;
}

interface GoogleMapsGeocodingResultBounds {
    northeast: GoogleMapsGeocodingResultCoord;
    southwest: GoogleMapsGeocodingResultCoord;
}

interface GoogleMapsGeocodingResultCoord {
    lat: number;
    lng: number;
}

interface GoogleMapsGeocodingResultAddressComponent {
    long_name: string;
    short_name: string;
    types: string[];
}

class GoogleMapsGeocoder implements IGeocoder {
    Type: ServiceType = ServiceType.Geocoder;
    Id: string = 'GoogleMapsGeocoder';

    Config: WebsiteGeocoderProviderConfig;

    constructor(config: WebsiteGeocoderProviderConfig) {
        this.Config = config;
    }

    Geocode(address: string): Promise<Coordinate> {
        return new Promise((resolve, reject) => {
            var req = new APIRequest(APIRequestMethod.GET, '/maps/api/geocode/json')
                .SetHost('https://maps.googleapis.com')
                .SetQuery({
                    address: address,
                    key: this,
                    components: 'country:AU'
                });

            Client.Request<GoogleMapsGeocodingResults>(req).then(res => {
                if(res == null || res.results.length == 0) {
                    reject();
                    return;
                }

                resolve({ Lat: res.results[0].geometry.location.lat, Lon: res.results[0].geometry.location.lng });
            }).catch(err => {
                Logger.Log(LogLevel.Error, 'Failed to geocode', address, err);
                reject(err);
            });
        });
    }
}

export { GoogleMapsGeocoder }
